import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUpSmall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.20711 11.2071C2.81658 11.5976 2.18342 11.5976 1.79289 11.2071C1.40237 10.8166 1.40237 10.1834 1.79289 9.79289L6.79289 4.79289C7.18342 4.40237 7.81658 4.40237 8.20711 4.79289L13.2071 9.79289C13.5976 10.1834 13.5976 10.8166 13.2071 11.2071C12.8166 11.5976 12.1834 11.5976 11.7929 11.2071L7.5 6.91421L3.20711 11.2071Z",
		fill: "currentColor"
	})
});
export default SvgArrowUpSmall;
